<template>
  <b-overlay :show="apiRslt.fetch.inProgress" rounded="sm" opacity="0.5" blur="none">
    <div class="row">
      <!------Ordre affichage------->
      <div class="col-md-3">
        <number-field
            name="Ordre affichage"
            property="orderPosition"
            v-model.number="$v.form.orderPosition.$model"
            :error="$v.form.orderPosition.$error"
            :isRequired="checkIfRequired($v.form.orderPosition)"
            errorCode="MESS003"
        />
      </div>
      <!------Nom------->
      <div class="col-md-9">
        <text-field
            name="Nom"
            property="name"
            v-model="$v.form.name.$model"
            :error="$v.form.name.$error"
            :isRequired="checkIfRequired($v.form.name)"
            errorCode="MESS001"
        />
      </div>
      <!------Section titre------->
      <div class="col-md-6">
        <text-field
            name="Titre"
            property="sectionTitle"
            v-model="$v.form.sectionTitle.$model"
            :error="$v.form.sectionTitle.$error"
            :isRequired="checkIfRequired($v.form.sectionTitle)"
            errorCode="MESS001"
        />
      </div>
      <!------Section sous-titre------->
      <div class="col-md-6">
        <text-field
            name="Sous-titre"
            property="sectionSubtitle"
            v-model="$v.form.sectionSubtitle.$model"
            :error="$v.form.sectionSubtitle.$error"
            :isRequired="checkIfRequired($v.form.sectionSubtitle)"
            errorCode="MESS001"
        />
      </div>
      <!------Fond couleur section------->
      <div class="col-md-6">
        <select-field
            v-model="$v.form.backgroundColor.$model"
            property="backgroundColor"
            name="Couleur"
            :options="backgroudSelect"
            :error="$v.form.backgroundColor.$error"
            :isRequired="checkIfRequired($v.form.backgroundColor)"
            errorCode="MESS004"
        />
      </div>
      <!------Prix section------->
      <div class="col-md-6">
        <price-field
            name="Prix Pastille"
            property="sectionPrice"
            v-model.number="$v.form.sectionPrice.$model"
            :error="$v.form.sectionPrice.$error"
            :isRequired="checkIfRequired($v.form.sectionPrice)"
            errorCode="MESS005"
        />
      </div>
      <!------Avertissement------->
      <comma-caution/>

      <!------Produits associés------->
      <div class="col-md-12">
        <tag-field v-show="form.products" name="Produit(s) associé(s)" :items="form.products" index="id" text="name"/>
      </div>

      <!------Sous-catégorie------->
      <div class="col-md-12">
        <small class="text-secondary">
          Sous-catégorie
        </small>
        <crud-item v-model="form.sousCategory" name="Sous-catégorie" :objToAdd="objToAdd" :deletedId="deletedId">
          <template v-slot:header="{ header }">
            <span :class="{'text-danger': $v.form.sousCategory.$each.$iter[index(header)].$error}" class="m-auto">
              {{ header.name ? header.name : 'Sous-catégorie' }}
            </span>
          </template>
          <template #error v-if="errorSousCatProduct">
            <span >Veuillez modifier les catégorie(s) / sous-catégorie(s) des produits</span>
          </template>
          <template v-slot:form="{ form }">
            <div class="row">
              <div class="col-md-6">
                <text-field
                    name="Nom"
                    :property="`name${form.index}`"
                    v-model="form.name"
                    :error="$v.form.sousCategory.$each.$iter[index(form)].name.$error"
                    errorCode="MESS001"
                />
              </div>
              <div class="col-md-6">
                <select-field
                    v-model="form.image"
                    :property="`image${form.index}`"
                    name="Image"
                    :options="imageOption"
                    :error="$v.form.sousCategory.$each.$iter[index(form)].image.$error"
                    errorCode="MESS004"
                />
              </div>
              <div class="col-md-12">
                <textarea-field
                    name="Information"
                    :property="`info${form.index}`"
                    v-model="form.info"
                    :error="$v.form.sousCategory.$each.$iter[index(form)].info.$error"
                    errorCode="MESS007"
                />
              </div>
              <div class="col-md-12">
                <tag-field v-show="form.product" name="Produits associé(s)" :items="form.product" index="id" text="name"/>
              </div>
            </div>
          </template>
        </crud-item>
      </div>
      
      <div class="col-md-12 mt-4">
        <button id="btn-crud-add" class="btn btn-primary float-right" v-show="operation==='add'" style="border-radius: 0;" @click="added">Ajouter</button>
        <button id="btn-crud-update" class="btn btn-primary float-right" v-show="operation==='update'" style="border-radius: 0;" @click="updated">Modifier</button>
        <button id="btn-crud-remove" class="btn float-left bg-danger text-white" v-show="operation==='update'" style="border-radius: 0;" @click="deleted">Supprimer</button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { minValue, required} from "vuelidate/lib/validators";
import {NumberField, PriceField, SelectField, TagField, TextareaField, TextField} from "@/core/components/form";
import CommaCaution from "@/core/components/common/CommaCaution";
import CrudItem from "@/core/components/CrudItem";
import {mapActions, mapState} from "vuex";
import {form} from "@/core/mixins";

export default {
  name: 'FormCategory',
  components: { NumberField, TextField, SelectField, PriceField, CrudItem, TextareaField,TagField,CommaCaution },
  mixins:[form],
  computed:{
    ...mapState('categories',['apiRslt','errorSousCatProduct'])
  },
  data() {
    return {
      form: {
        name: "",
        orderPosition: 0,
        products:[],
        sousCategory: [],
        sectionTitle: "",
        sectionSubtitle: "",
        backgroundColor: "",
        sectionPrice: null
      },
      init: {
        name: "",
        orderPosition: 0,
        products:[],
        sousCategory: [],
        sectionTitle: "",
        sectionSubtitle: "",
        backgroundColor: "",
        sectionPrice: null
      },
      backgroudSelect:[
        {text: 'Vert', value: 'has-background-green'},
        {text: 'Bleu', value: 'has-background-blue'},
        {text: 'Jaune', value: 'has-background-yellow'},
        {text: 'Rose', value: 'has-background-pink'},
      ],
      objToAdd:{ name:'', info: '', image: '' },
      imageOption:[
        { text: 'Bière', value: 'biere.png'},
        { text: 'Canette', value: 'canette.png'},
        { text: 'Bouteille d\'eau', value: 'eau.png'},
        { text: 'Jus Local', value: 'jus_local.png'},
        { text: 'Soda', value: 'soda.png'}
      ]
    }
  },
  methods:{
    index(item){
      return this.form.sousCategory.findIndex(x => x === item)
    },
    added(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.addCategory(this.form)
    },
    updated(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.updateCategory(this.form)
    },
    deleted(){
      this.deleteCategory(this.form.id)
      this.reset(this.form.id)
    },
    ...mapActions('categories',['addCategory','updateCategory','deleteCategory'])
  },
  validations() {
    return {
      form: {
        name: { required },
        orderPosition: { required,minValue: minValue(1) },
        sousCategory: {
          $each: {
            name: { required },
            image:{ required },
            info:{}
          }
        },
        sectionTitle: { required },
        sectionSubtitle: {  },
        backgroundColor: { required },
        sectionPrice: { required },
      }
    }
  }
}
</script>

<style scoped>

.form-select {
  border-radius: 0;
}
.btn:hover:not(.btn-icon-only) {
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
  transform: translateY(-1px);
}
.btn-primary {
  color: #000;
  background-color: #5e72e4 !important;
  border-color: #5e72e4 !important;
  color: white !important;
}
.btn {
  border-radius: 0.5rem;
}

</style>
